import DataGrid from "./DataGrid";

export default function componentsOverrides(theme) {
  return Object.assign(
    DataGrid(theme)
  )
}